import React, { forwardRef } from 'react';

const RecipeTypeAnnotationsIcon = forwardRef((props, ref) => {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z"
        fill="#C0E5D9"
      />
      <path
        d="M12.0011 5L13.1331 11.424L12.0011 19C10.6681 18.9997 9.36369 18.6139 8.24507 17.889L6.19707 18.9C6.04316 18.9769 5.86896 19.0034 5.69914 18.9758C5.52932 18.9482 5.37248 18.8679 5.25082 18.7463C5.12916 18.6246 5.04885 18.4678 5.02126 18.2979C4.99367 18.1281 5.02019 17.9539 5.09707 17.8L6.09707 15.747C5.42662 14.689 5.05231 13.4706 5.01318 12.2187C4.97405 10.9668 5.27154 9.72733 5.8746 8.62957C6.47767 7.53181 7.36424 6.61596 8.44183 5.97755C9.51942 5.33914 10.7486 5.00156 12.0011 5V5Z"
        fill="#2EE6A8"
      />
      <path
        d="M18.998 11.994C18.9975 13.8509 18.26 15.6317 16.9476 16.9453C15.6351 18.2589 13.855 18.9979 11.998 19V5H12.0041C12.9225 5 13.832 5.18091 14.6805 5.53239C15.5291 5.88387 16.3001 6.39904 16.9496 7.0485C17.599 7.69795 18.1142 8.46896 18.4657 9.31751C18.8171 10.1661 18.998 11.0755 18.998 11.994Z"
        fill="#24B3B3"
      />
      <path
        d="M12.004 8.59698L12.378 9.01898L12.004 9.44098H8.69202C8.5801 9.44098 8.47276 9.39652 8.39362 9.31738C8.31448 9.23824 8.27002 9.1309 8.27002 9.01898C8.27002 8.90706 8.31448 8.79972 8.39362 8.72058C8.47276 8.64144 8.5801 8.59698 8.69202 8.59698H12.004Z"
        fill="#24B3B3"
      />
      <path
        d="M7.77014 11.424H8.89414C9.00606 11.424 9.1134 11.3795 9.19254 11.3004C9.27168 11.2212 9.31615 11.1139 9.31615 11.002C9.31615 10.89 9.27168 10.7827 9.19254 10.7036C9.1134 10.6244 9.00606 10.58 8.89414 10.58H7.77014C7.65822 10.58 7.55089 10.6244 7.47175 10.7036C7.39261 10.7827 7.34814 10.89 7.34814 11.002C7.34814 11.1139 7.39261 11.2212 7.47175 11.3004C7.55089 11.3795 7.65822 11.424 7.77014 11.424Z"
        fill="#24B3B3"
      />
      <path
        d="M12.0014 10.581L12.3754 11.003L12.0014 11.425H10.5334C10.4763 11.4278 10.4192 11.4189 10.3657 11.399C10.3121 11.3791 10.2632 11.3485 10.2218 11.3091C10.1804 11.2697 10.1474 11.2223 10.1249 11.1697C10.1024 11.1172 10.0908 11.0606 10.0908 11.0035C10.0908 10.9463 10.1024 10.8898 10.1249 10.8373C10.1474 10.7847 10.1804 10.7373 10.2218 10.6979C10.2632 10.6585 10.3121 10.6279 10.3657 10.608C10.4192 10.588 10.4763 10.5792 10.5334 10.582L12.0014 10.581Z"
        fill="#24B3B3"
      />
      <path
        d="M12.0011 12.564L12.3751 12.986L12.0011 13.408H7.77015C7.65823 13.408 7.55089 13.3635 7.47175 13.2844C7.39261 13.2052 7.34814 13.0979 7.34814 12.986C7.34814 12.874 7.39261 12.7667 7.47175 12.6876C7.55089 12.6084 7.65823 12.564 7.77015 12.564H12.0011Z"
        fill="#24B3B3"
      />
      <path
        d="M12.004 14.547L12.504 14.969L12.004 15.391H8.69202C8.5801 15.391 8.47276 15.3465 8.39362 15.2674C8.31448 15.1883 8.27002 15.0809 8.27002 14.969C8.27002 14.8571 8.31448 14.7497 8.39362 14.6706C8.47276 14.5915 8.5801 14.547 8.69202 14.547H12.004Z"
        fill="#24B3B3"
      />
      <path
        d="M15.746 9.01898C15.746 8.90706 15.7016 8.79972 15.6224 8.72058C15.5433 8.64144 15.436 8.59698 15.324 8.59698H11.998V9.44098H15.3221C15.3776 9.44124 15.4327 9.43053 15.4842 9.40944C15.5356 9.38835 15.5823 9.3573 15.6217 9.31808C15.6611 9.27887 15.6924 9.23227 15.7137 9.18094C15.7351 9.12961 15.746 9.07457 15.746 9.01898Z"
        fill="#0D90BC"
      />
      <path
        d="M16.665 11.003C16.665 10.8911 16.6206 10.7837 16.5414 10.7046C16.4623 10.6254 16.355 10.581 16.243 10.581H11.998V11.424H16.2401C16.2956 11.4244 16.3507 11.4138 16.4022 11.3928C16.4537 11.3719 16.5005 11.3409 16.54 11.3018C16.5795 11.2627 16.6109 11.2162 16.6324 11.1649C16.6538 11.1136 16.6649 11.0586 16.665 11.003Z"
        fill="#0D90BC"
      />
      <path
        d="M13.898 12.986C13.898 12.874 13.8536 12.7667 13.7744 12.6876C13.6953 12.6084 13.588 12.564 13.476 12.564H11.998V13.408H13.4771C13.5888 13.4077 13.6959 13.3631 13.7748 13.284C13.8537 13.2049 13.898 13.0977 13.898 12.986Z"
        fill="#0D90BC"
      />
      <path
        d="M16.2443 12.564H15.1203C15.0649 12.564 15.01 12.5749 14.9588 12.5961C14.9076 12.6173 14.8611 12.6484 14.8219 12.6876C14.7827 12.7267 14.7516 12.7733 14.7304 12.8245C14.7092 12.8757 14.6982 12.9305 14.6982 12.986C14.6982 13.0414 14.7092 13.0963 14.7304 13.1475C14.7516 13.1987 14.7827 13.2452 14.8219 13.2844C14.8611 13.3235 14.9076 13.3546 14.9588 13.3758C15.01 13.397 15.0649 13.408 15.1203 13.408H16.2443C16.2997 13.408 16.3546 13.397 16.4058 13.3758C16.457 13.3546 16.5035 13.3235 16.5427 13.2844C16.5818 13.2452 16.6129 13.1987 16.6341 13.1475C16.6553 13.0963 16.6663 13.0414 16.6663 12.986C16.6663 12.9305 16.6553 12.8757 16.6341 12.8245C16.6129 12.7733 16.5818 12.7267 16.5427 12.6876C16.5035 12.6484 16.457 12.6173 16.4058 12.5961C16.3546 12.5749 16.2997 12.564 16.2443 12.564Z"
        fill="#0D90BC"
      />
      <path
        d="M15.325 14.547H11.998V15.391H15.3221C15.434 15.391 15.5413 15.3465 15.6205 15.2674C15.6996 15.1883 15.744 15.0809 15.744 14.969C15.744 14.8571 15.6996 14.7497 15.6205 14.6706C15.5413 14.5915 15.434 14.547 15.3221 14.547H15.325Z"
        fill="#0D90BC"
      />
    </svg>
  );
});

export default RecipeTypeAnnotationsIcon;
